<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 10V13.5H2.5V4H6V2.5H1V15H13.5V10H12Z" [attr.fill]="color" />
    <path fill-rule="evenodd" clip-rule="evenodd"
        d="M8.99997 1V2.5H12.44L6.46997 8.47L7.52997 9.53L13.5 3.56V7H15V1H8.99997Z" [attr.fill]="color" />
</svg>